import { blogItemCategoryPillStyle } from '../../BlogList/BlogList.styles';
import TAGLink from '@shared-components/components/TAGLink';
import { useAppContext } from '@shared-components/context/AppContextProvider.ctx';
const toSentenceCase = (tag: string) => {
  const normalizedTag = tag.trim().toLowerCase();
  return normalizedTag.charAt(0).toUpperCase() + normalizedTag.slice(1);
};
const getUniqueTags = (tags: Array<string>) => {
  const uniqueTags = new Map<string, string>();
  tags.forEach(tag => {
    const normalizedTag = tag.trim().toLowerCase();
    if (normalizedTag && !uniqueTags.has(normalizedTag)) {
      uniqueTags.set(normalizedTag, toSentenceCase(tag));
    }
  });
  return Array.from(uniqueTags, ([tagPath, label]) => ({
    tagPath,
    label
  }));
};
export default function BlogTags({
  tags
}: Readonly<{
  tags: Array<string>;
}>) {
  const {
    config
  } = useAppContext();
  const blogRootPath = config.features.blogs.root.endsWith('/') ? config.features.blogs.root : `${config.features.blogs.root}/`;
  const blogTagPath = `${blogRootPath}tag/`;
  const uniqueTags = getUniqueTags(tags ?? []);
  if (uniqueTags.length === 0) {
    return null;
  }
  return <div data-testid="blog-tags-container" style={{
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.5rem'
  }} data-sentry-component="BlogTags" data-sentry-source-file="BlogTags.tsx">
			{uniqueTags.map(({
      tagPath,
      label
    }) => {
      return <TAGLink key={tagPath} href={`${blogTagPath}${tagPath}`} title={label} linkSx={blogItemCategoryPillStyle} dataTestId={`blog_${tagPath}`}>
						{label}
					</TAGLink>;
    })}
		</div>;
}